import { Component, Input } from '@angular/core';
import { ImageSize, ImageWithLabelSize } from '../../../types/common.types';
import { Image } from './models/image.interface';

@Component({
  selector: 'idp-image-with-label',
  templateUrl: './image-with-label.component.html',
  styleUrls: ['./image-with-label.component.scss']
})
export class ImageWithLabelComponent {
  @Input() label: string = '' as string;
  @Input() image: Image = {} as Image;
  @Input() size: ImageWithLabelSize = 'base';
  @Input() imageSize: ImageSize = 'base';
}
